export enum TelephoneTypes {
    PHONENUMBER_MOBILE,
    PHONENUMBER_LANDLINE
}
